import { ArrowRight } from '@phosphor-icons/react';
import './button.css';

/**
 * @param {import('react').ElementType} [as] — элемент кнопки. `'a'` — для
 *   перехода по ссылке с видом кнопки: ссылка остаётся ссылкой (Cmd+клик,
 *   «открыть в новой вкладке»), а классы не приходится копировать руками.
 * @param {boolean} [arrow] — таблетка со стрелкой в белом круге у правого
 *   края (#1335, язык героя S2 витрины): подпись слева, круг справа. Круг —
 *   часть кнопки, а не вторая кнопка; доступное имя даёт подпись.
 */
const Button = ({
  as: Tag = 'button',
  children,
  className = '',
  variant = 'default',
  size = 'default',
  onClick,
  arrow = false,
  ...props
}) => {
  const baseClasses = 'btn';

  const variants = {
    default: 'btn--default',
    // Чёрная заливка (#1335): главное действие, когда синее уже занято
    // соседом — например, кнопка формы рядом с синей.
    dark: 'btn--dark',
    secondary: 'btn--secondary',
    outline: 'btn--outline',
    ghost: 'btn--ghost',
    text: 'btn--text',
    'text-primary': 'btn--text-primary'
  };

  const sizes = {
    sm: 'btn--sm',
    default: 'btn--md',
    lg: 'btn--lg',
    // Только иконка: квадрат в высоту кнопки, без подписи. Доступное имя —
    // через `aria-label` у вызывающего (#1456).
    icon: 'btn--icon'
  };

  const classes = `${baseClasses} ${variants[variant]} ${sizes[size]}${
    arrow ? ' btn--arrow' : ''
  } ${className}`;

  return (
    <Tag className={classes} onClick={onClick} {...props}>
      {children}
      {arrow && (
        <span className="btn__arrow" aria-hidden="true">
          <ArrowRight size={16} weight="bold" />
        </span>
      )}
    </Tag>
  );
};

export { Button };
